export default "__VITE_ASSET__BfC0rjuE__"